import http from './http'
import type { Batch, Job, RenderPayload } from '@/types/api'

export const jobsService = {
  async queue(): Promise<Job[]> {
    const { data } = await http.get<Job[]>('/jobs/queue')
    return data
  },

  async render(payload: RenderPayload): Promise<Batch<Job>> {
    const { data } = await http.post<Batch<Job>>('/jobs/render', payload)
    return data
  },
}
